import React, { useState, useEffect } from 'react';
import { CURRENT_VERSION, PATCH_NOTES } from '../patchNotes';

const PatchNotesModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleOpen = () => setOpen(true);
    window.addEventListener('openPatchNotesModal', handleOpen);
    return () => window.removeEventListener('openPatchNotesModal', handleOpen);
  }, []);

  if (!open) return null;

  const typeIcons = {
    feature: '✨',
    fix: '🔧',
    improvement: '⚡',
    security: '🔒'
  };

  return (
    <div
      onClick={() => setOpen(false)}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10001,
        animation: 'fadeIn 0.2s ease-out'
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: '16px',
          padding: '24px',
          maxWidth: '500px',
          width: '90%',
          maxHeight: '80vh',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          animation: 'slideUp 0.3s ease-out',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '44px', height: '44px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '12px',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
            </div>
            <div>
              <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: '#202124' }}>What's New</h3>
              <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af' }}>Current version: {CURRENT_VERSION}</p>
            </div>
          </div>
          <button
            onClick={() => setOpen(false)}
            onMouseOver={(e) => e.currentTarget.style.background = '#f1f3f4'}
            onMouseOut={(e) => e.currentTarget.style.background = 'none'}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              padding: '8px', borderRadius: '50%', transition: 'background 0.2s'
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#5f6368" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Legend */}
        <div style={{
          display: 'flex', gap: '16px', padding: '12px',
          background: '#f8f9fa', borderRadius: '8px',
          marginBottom: '16px', flexWrap: 'wrap'
        }}>
          {Object.entries(typeIcons).map(([type, icon]) => (
            <span key={type} style={{ fontSize: '11px', color: '#5f6368', display: 'flex', alignItems: 'center', gap: '4px' }}>
              {icon} {type.charAt(0).toUpperCase() + type.slice(1)}
            </span>
          ))}
        </div>

        {/* Scrollable content */}
        <div style={{ flex: 1, overflowY: 'auto', paddingRight: '8px' }}>
          {PATCH_NOTES.map((release, i) => (
            <div key={release.version} style={{
              marginBottom: '20px', paddingBottom: '20px',
              borderBottom: i < PATCH_NOTES.length - 1 ? '1px solid #e5e7eb' : 'none'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white', padding: '4px 10px', borderRadius: '12px',
                    fontSize: '12px', fontWeight: 600
                  }}>v{release.version}</span>
                  <span style={{ fontSize: '16px', fontWeight: 600, color: '#202124' }}>{release.title}</span>
                </div>
                <span style={{ fontSize: '12px', color: '#9ca3af' }}>{release.date}</span>
              </div>
              <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                {release.changes.map((change, j) => (
                  <li key={j} style={{
                    display: 'flex', alignItems: 'flex-start', gap: '8px',
                    marginBottom: '8px', fontSize: '13px', color: '#5f6368'
                  }}>
                    <span style={{ flexShrink: 0 }}>{typeIcons[change.type] || '✨'}</span>
                    <span>{change.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
      `}</style>
    </div>
  );
};

export default PatchNotesModal;